import { render, staticRenderFns } from "./EmailFormContent.vue?vue&type=template&id=12ec886a"
import script from "./EmailFormContent.vue?vue&type=script&lang=js"
export * from "./EmailFormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports